import { useState } from 'react';
import { Container, Tabs, Tab } from 'react-bootstrap';
import OrderSegmentTab from './components/OrderSegmentTab';

type TabKey = 'order-segment' | 'shipping-invoice' | 'revision';

const SHIPPING_INVOICE_FORM_URL = 'https://n8n.skin-seoul.work/form/ca6f438c-7cc3-49d4-8036-5e0ba879b42c';

export default function ShippingFeePage() {
  const [activeTab, setActiveTab] = useState<TabKey>('order-segment');

  return (
    <Container fluid className="p-4">
      <h4 className="mb-1">Shipping Fee</h4>
      <p className="text-muted mb-4">
        Order segment reporting, shipping fee invoices, and revision invoices.
      </p>

      <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k as TabKey)} className="mb-4">
        <Tab eventKey="order-segment" title="Order Segment">
          <OrderSegmentTab />
        </Tab>
        <Tab eventKey="shipping-invoice" title="Shipping Fee Invoice">
          <iframe
            src={SHIPPING_INVOICE_FORM_URL}
            style={{ maxWidth: 640, width: '100%', height: '85vh', border: 'none' }}
            title="Shipping Fee Invoice Form"
            sandbox="allow-scripts allow-forms allow-same-origin"
          />
        </Tab>
        <Tab eventKey="revision" title="Revision Invoice">
          <div className="text-muted py-5 text-center">
            <p>Revision Invoice — coming soon.</p>
          </div>
        </Tab>
      </Tabs>
    </Container>
  );
}
